import Head from "next/head";
import { make as TraitsInfoPage } from "../../../../src/info/TraitsInfoPage.bs";

export default function TraitsInfo() {
  return (
    <>
      <Head>
        <title>Traits Set 7.5 TFT Info</title>
      </Head>
      <TraitsInfoPage set={76} />
    </>
  );
}
